import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { useAriaLiveRegion } from '../../hooks/use_aria_live_region.js';
import { Button } from '../Button/Button.js';
import '../Icons/IconActivity.js';
import '../Icons/IconActivityFilled.js';
import '../Icons/IconActivityOff.js';
import '../Icons/IconAdd.js';
import '../Icons/IconAddToCart.js';
import '../Icons/IconAlignBottom.js';
import '../Icons/IconAlignCenter.js';
import '../Icons/IconAlignJustify.js';
import '../Icons/IconAlignLeft.js';
import '../Icons/IconAlignMiddle.js';
import '../Icons/IconAlignRight.js';
import '../Icons/IconAlignTop.js';
import '../Icons/IconAnnotate.js';
import '../Icons/IconApps.js';
import '../Icons/IconArchive.js';
import '../Icons/IconArrowBack.js';
import '../Icons/IconArrowDown.js';
import '../Icons/IconArrowLeft.js';
import '../Icons/IconArrowRight.js';
import '../Icons/IconArrowUp.js';
import '../Icons/IconAskExpert.js';
import '../Icons/IconAtMention.js';
import '../Icons/IconAttach.js';
import '../Icons/IconBarChart.js';
import '../Icons/IconBold.js';
import '../Icons/IconCalendar.js';
import '../Icons/IconCalendarDay.js';
import '../Icons/IconCaretDown.js';
import '../Icons/IconCaretUp.js';
import { IconCheck } from '../Icons/IconCheck.js';
import '../Icons/IconClose.js';
import '../Icons/IconCloseContextualPanel.js';
import '../Icons/IconCloudSync.js';
import '../Icons/IconCloudUpload.js';
import '../Icons/IconCode.js';
import '../Icons/IconCollapsePanel.js';
import '../Icons/IconCollection.js';
import '../Icons/IconColor.js';
import '../Icons/IconColumns.js';
import '../Icons/IconComment.js';
import '../Icons/IconContentPlanner.js';
import '../Icons/IconCopy.js';
import '../Icons/IconCorporations.js';
import '../Icons/IconCRM.js';
import '../Icons/IconCustomDelivery.js';
import '../Icons/IconCustomize.js';
import '../Icons/IconDash.js';
import '../Icons/IconDatasource.js';
import '../Icons/IconDelete.js';
import '../Icons/IconDependentField.js';
import '../Icons/IconDocCenter.js';
import '../Icons/IconDownload.js';
import '../Icons/IconDrag.js';
import '../Icons/IconEdit.js';
import '../Icons/IconEditForm.js';
import '../Icons/IconEditNew.js';
import '../Icons/IconEmail.js';
import '../Icons/IconEmailBlast.js';
import '../Icons/IconEmailComponent.js';
import '../Icons/IconEmailTemplate.js';
import '../Icons/IconEmoji.js';
import '../Icons/IconEngagements.js';
import '../Icons/IconExpire.js';
import '../Icons/IconExport.js';
import '../Icons/IconExternal.js';
import '../Icons/IconFavoriteSelected.js';
import '../Icons/IconFavoriteUnselected.js';
import '../Icons/IconFile.js';
import '../Icons/IconFileAdd.js';
import '../Icons/IconFileEdit.js';
import '../Icons/IconFileLock.js';
import '../Icons/IconFileMove.js';
import '../Icons/IconFileRemove.js';
import '../Icons/IconFileSearch.js';
import '../Icons/IconFileShare.js';
import '../Icons/IconFileStar.js';
import '../Icons/IconFileSync.js';
import '../Icons/IconFileZip.js';
import '../Icons/IconFilter.js';
import '../Icons/IconFolder.js';
import '../Icons/IconFolderAdd.js';
import '../Icons/IconFolderEdit.js';
import '../Icons/IconFolderOpen.js';
import '../Icons/IconFolderRemove.js';
import '../Icons/IconFolderSearch.js';
import '../Icons/IconFolderShare.js';
import '../Icons/IconFolderStar.js';
import '../Icons/IconFolderSync.js';
import '../Icons/IconFolderTeam.js';
import '../Icons/IconFolderZip.js';
import '../Icons/IconFullscreen.js';
import '../Icons/IconGenericSort.js';
import '../Icons/IconGlobal.js';
import '../Icons/IconGoogleDrive.js';
import '../Icons/IconGrid.js';
import '../Icons/IconGridPattern1.js';
import '../Icons/IconGroupBy.js';
import '../Icons/IconHandClosed.js';
import '../Icons/IconHandOpen.js';
import '../Icons/IconHome.js';
import '../Icons/IconIndentDecrease.js';
import '../Icons/IconIndentIncrease.js';
import '../Icons/IconInsights.js';
import '../Icons/IconIntegrations.js';
import '../Icons/IconInternalSync.js';
import '../Icons/IconItalic.js';
import '../Icons/IconLaptop.js';
import '../Icons/IconLayout.js';
import '../Icons/IconLibrary.js';
import '../Icons/IconLightbulb.js';
import '../Icons/IconLike.js';
import '../Icons/IconLikeDisabled.js';
import '../Icons/IconLineChart.js';
import '../Icons/IconLineHeight.js';
import '../Icons/IconLink.js';
import '../Icons/IconList.js';
import '../Icons/IconListNumbers.js';
import '../Icons/IconLiveSocial.js';
import '../Icons/IconLocate.js';
import '../Icons/IconLock.js';
import '../Icons/IconLogic.js';
import '../Icons/IconMedia.js';
import '../Icons/IconMediaCC.js';
import '../Icons/IconMediaCCActive.js';
import '../Icons/IconMediaControlPrevious.js';
import '../Icons/IconMediaForward.js';
import '../Icons/IconMediaFull.js';
import '../Icons/IconMediaLow.js';
import '../Icons/IconMediaMedium.js';
import '../Icons/IconMediaMute.js';
import '../Icons/IconMediaNext.js';
import '../Icons/IconMediaPause.js';
import '../Icons/IconMediaPlay.js';
import '../Icons/IconMediaRewind.js';
import '../Icons/IconMediaStop.js';
import '../Icons/IconMeetings.js';
import '../Icons/IconMenu.js';
import '../Icons/IconModule.js';
import '../Icons/IconMore.js';
import '../Icons/IconMove.js';
import '../Icons/IconMultiSelect.js';
import '../Icons/IconNews.js';
import '../Icons/IconNumeric.js';
import '../Icons/IconOpenContextualPanel.js';
import '../Icons/IconOpenPanel.js';
import '../Icons/IconPage.js';
import '../Icons/IconPageBack.js';
import '../Icons/IconPageDown.js';
import '../Icons/IconPageForward.js';
import '../Icons/IconPageUp.js';
import '../Icons/IconPaperclip.js';
import '../Icons/IconParagraph.js';
import '../Icons/IconPieChart.js';
import '../Icons/IconPin.js';
import '../Icons/IconPortfolio.js';
import '../Icons/IconPresentation.js';
import '../Icons/IconPresentationMode.js';
import '../Icons/IconPreview.js';
import '../Icons/IconPreviewOff.js';
import '../Icons/IconPrint.js';
import '../Icons/IconProject.js';
import '../Icons/IconPublish.js';
import '../Icons/IconPublishing.js';
import '../Icons/IconPushNotification.js';
import '../Icons/IconPuzzlePiece.js';
import '../Icons/IconQuote.js';
import '../Icons/IconRecord.js';
import '../Icons/IconRecordActive.js';
import '../Icons/IconRedo.js';
import '../Icons/IconRefresh.js';
import '../Icons/IconRemoveFormatting.js';
import '../Icons/IconReorder.js';
import '../Icons/IconRequest.js';
import '../Icons/IconRotate.js';
import '../Icons/IconRSS.js';
import '../Icons/IconSave.js';
import '../Icons/IconScreen.js';
import '../Icons/IconScreenFitHeight.js';
import '../Icons/IconScreenFitWidth.js';
import '../Icons/IconScreenNext.js';
import '../Icons/IconScreenPrevious.js';
import '../Icons/IconScreenShare.js';
import '../Icons/IconSearch.js';
import '../Icons/IconSettings.js';
import '../Icons/IconShare.js';
import '../Icons/IconSharedLink.js';
import '../Icons/IconSingleSelect.js';
import '../Icons/IconSortDown.js';
import '../Icons/IconSortUp.js';
import '../Icons/IconSoundOff.js';
import '../Icons/IconSoundOn.js';
import '../Icons/IconStatusAdd.js';
import '../Icons/IconStatusAddFilled.js';
import '../Icons/IconStatusCheck.js';
import '../Icons/IconStatusCheckFilled.js';
import '../Icons/IconStatusClose.js';
import '../Icons/IconStatusCloseFilled.js';
import '../Icons/IconStatusDot.js';
import { IconStatusError } from '../Icons/IconStatusError.js';
import '../Icons/IconStatusHelp.js';
import '../Icons/IconStatusHelpFilled.js';
import '../Icons/IconStatusInformation.js';
import '../Icons/IconStatusInformationFilled.js';
import '../Icons/IconStatusPause.js';
import '../Icons/IconStatusPauseFilled.js';
import '../Icons/IconStatusPlay.js';
import '../Icons/IconStatusPlayFilled.js';
import '../Icons/IconStatusRemove.js';
import '../Icons/IconStatusRemoveFilled.js';
import '../Icons/IconStatusUrgent.js';
import '../Icons/IconStatusUrgentFilled.js';
import '../Icons/IconStatusWarning.js';
import '../Icons/IconSubtask.js';
import '../Icons/IconSync.js';
import '../Icons/IconTableColumn.js';
import '../Icons/IconTableGrid.js';
import '../Icons/IconTableRow.js';
import '../Icons/IconTags.js';
import '../Icons/IconTask.js';
import '../Icons/IconTasks.js';
import '../Icons/IconTaxonomy.js';
import '../Icons/IconTemplate.js';
import '../Icons/IconText.js';
import '../Icons/IconTextCleared.js';
import '../Icons/IconTextField.js';
import '../Icons/IconTextImageLeft.js';
import '../Icons/IconTextImageRight.js';
import '../Icons/IconTextIndentLeft.js';
import '../Icons/IconTextIndentRight.js';
import '../Icons/IconTextSingle.js';
import '../Icons/IconTextSize.js';
import '../Icons/IconTextStrikethrough.js';
import '../Icons/IconTextSubscript.js';
import '../Icons/IconTextSuperscript.js';
import '../Icons/IconTextUnderline.js';
import '../Icons/IconTrendingDown.js';
import '../Icons/IconTrendingUp.js';
import '../Icons/IconTrueFalse.js';
import '../Icons/IconTv.js';
import '../Icons/IconTwoColumn.js';
import '../Icons/IconUndo.js';
import '../Icons/IconUnlike.js';
import '../Icons/IconUnlink.js';
import '../Icons/IconUnlock.js';
import '../Icons/IconUnpublish.js';
import '../Icons/IconUpload.js';
import '../Icons/IconUser.js';
import '../Icons/IconUserAdd.js';
import '../Icons/IconUserAddToMeeting.js';
import '../Icons/IconUserGroup.js';
import '../Icons/IconUserRating.js';
import '../Icons/IconUserRemove.js';
import '../Icons/IconUserSearch.js';
import '../Icons/IconUserSettings.js';
import '../Icons/IconUserShare.js';
import '../Icons/IconUserSync.js';
import '../Icons/IconVariables.js';
import '../Icons/IconVideo.js';
import '../Icons/IconVideoPause.js';
import '../Icons/IconVideoRewind15.js';
import '../Icons/IconVideoSkip15.js';
import '../Icons/IconWorkspace.js';
import '../Icons/IconZoomIn.js';
import '../Icons/IconZoomOut.js';
import { Spinner } from '../Spinner/Spinner.js';
import { jsx } from 'react/jsx-runtime';

var _excluded = ["status"];
var ContextualButton = function ContextualButton(_ref) {
  var _props$successLabel, _props$errorLabel, _props$loadingLabel;
  var _ref$status = _ref.status,
    statusProp = _ref$status === void 0 ? "default" : _ref$status,
    props = _objectWithoutProperties(_ref, _excluded);
  var _React$useState = React.useState(statusProp),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    currentStatus = _React$useState2[0],
    setCurrentStatus = _React$useState2[1];
  React.useEffect(function () {
    if (currentStatus === "loading") {
      setTimeout(function () {
        return setCurrentStatus(statusProp);
      }, 1e3);
    } else {
      setCurrentStatus(statusProp);
    }
  }, [statusProp]);
  var label = props.label;
  var startAdornment = props.startAdornment;
  var buttonVariant = props.variant;
  var disabled = props.disabled;
  switch (currentStatus) {
    case "default":
      break;
    case "success":
      label = (_props$successLabel = props.successLabel) !== null && _props$successLabel !== void 0 ? _props$successLabel : "Success";
      startAdornment = IconCheck;
      break;
    case "error":
      label = (_props$errorLabel = props.errorLabel) !== null && _props$errorLabel !== void 0 ? _props$errorLabel : "Failed";
      startAdornment = IconStatusError;
      buttonVariant = "warning";
      break;
    case "loading":
      label = (_props$loadingLabel = props.loadingLabel) !== null && _props$loadingLabel !== void 0 ? _props$loadingLabel : "Loading";
      startAdornment = /*#__PURE__*/jsx(Spinner, {
        size: 16
      });
      buttonVariant = "secondary";
      disabled = true;
      break;
  }
  useAriaLiveRegion({
    content: label,
    showing: currentStatus !== "default",
    type: "assertive"
  });
  return /*#__PURE__*/jsx(Button, _objectSpread(_objectSpread({}, props), {}, {
    disabled: disabled,
    label: label,
    onClick: props.onClick,
    startAdornment: startAdornment,
    variant: buttonVariant
  }));
};
ContextualButton.displayName = "ContextualButton";

export { ContextualButton };
